const tableStyle = {
    headerStyle:{background: '#F5F6F8','font-weight':600,color:'#606266','text-align':'center'},
    cellStyle:{},
    // headerColor:"#606266"
}

export default tableStyle;